import _ from 'lodash'
import { Checkbox, Col, Input, notification, Row } from 'antd'
import Button from 'antd-button-color'
import React, { useEffect, useState } from 'react'
import { checkValidAttack } from '../../../../shared/scoring'
import { attackType } from '../../../../shared/enums'
import { QuestionCircleOutlined } from '@ant-design/icons'

const TableScoreCard = (props) => {
  const [round, setRound] = useState({})
  const [player1Victory, setPlayer1Victory] = useState(false)
  const [player2Victory, setPlayer2Victory] = useState(false)
  const [isAdvancedHelpVisible, setIsAdvancedHelpVisible] = useState(false)

  useEffect(() => {
    const newRound = JSON.parse(JSON.stringify(props.round))

    if (!props.round.teams[0].advanced) {
      newRound.teams[0].advanced = new Array(props.config.score).fill(null)
    }
    if (!props.round.teams[1].advanced) {
      newRound.teams[1].advanced = new Array(props.config.score).fill(null)
    }

    if (props.round.teams[0].isWinner) {
      setPlayer1Victory(true)
    }
    if (props.round.teams[1].isWinner) {
      setPlayer2Victory(true)
    }

    setRound(newRound)
    // eslint-disable-next-line
  }, [])

  const cardStyle = {
    border: '1px solid #000',
    margin: '2em'
  }

  const handleAdvancedPoints = (event, p1, p2) => {
    const player1Index = round.teams.findIndex(t => t.id === p1)
    const player2Index = round.teams.findIndex(t => t.id === p2)
    const player1 = round.teams[player1Index]
    const player2 = round.teams[player2Index]

    if (!player1.score) player1.score = 0
    if (!player2.score) player2.score = 0

    if (!checkValidAttack(event)) return

    const newRound = JSON.parse(JSON.stringify(round))
    let current = player1.score || 0
    if (current === 'V') current = props.config.score
    let isRemove = false

    let attack
    if (['Backspace', 'Delete'].includes(event.key)) {
      const baseAttack = attackType[_.toLower(player1.advanced[current - 1])]
      attack = {
        value: baseAttack.value
      }
      current += -1 * baseAttack.value
      isRemove = true
    } else if (event.key === 'Tab') {
      event.preventDefault()
      let nextPlayer = 'player1'
      if (event.target.name.includes('player1')) {
        nextPlayer = 'player2'
      }

      const nextFieldName = `${nextPlayer}_1`
      const nextfield = document.querySelector(
        `input[name=${nextFieldName}]`
      )
      if (nextfield !== null) {
        nextfield.focus()
      }
      return
    } else {
      attack = attackType[_.toLower(event.key)]
    }

    let victoryScore = props.config.score
    if (_.first(player2.score) === 'V' && player2.score.length > 1) {
      victoryScore = parseInt(player2.slice(1), 10)
    }

    if (current + attack.value >= victoryScore && _.first(player2.score) === 'V') {
      // do nothing
    } else {
      for (let i = 0; i < attack.value; i += 1) {
        if (isRemove) {
          player1.advanced[current + i] = null
        } else {
          if (current + i < props.config.score) {
            if (current + i === props.config.score - 1) {
              player1.advanced[current + i] = _.toUpper(event.key)
            } else {
              if (i + 1 === attack.value) {
                player1.advanced[current + i] = _.toUpper(event.key)
              } else {
                player1.advanced[current + i] = 'x'
              }
            }
          }
        }
      }

      let newScore = player1.score || 0
      if (newScore === 'V') {
        newScore = props.config.score
      } else if (_.first(newScore) === 'V') {
        newScore = parseInt(newScore.slice(1), 10)
      }
      if (isRemove) {
        newScore -= attack.value
      } else {
        if (_.first(newScore) !== 'V') {
          if (!_.isNumber(newScore)) newScore = _.toInteger(newScore)
          newScore += attack.value
        }
      }

      if (newScore >= props.config.score && _.first(player2.score) !== 'V') {
        newScore = 'V'
      } else if (newScore >= props.config.score && _.first(player2.score) === 'V') {
        if (player2.score.length > 1) {
          newScore = parseInt(player2.score.slice(1), 10) - 1
        } else {
          newScore = props.config.score - 1
        }
      }

      player1.score = newScore
    }
    newRound.teams[player1Index] = player1

    setRound(newRound)

    props.onMatchScore(newRound)
  }

  const handleChange = (event, obj) => {
    const newRound = JSON.parse(JSON.stringify(round))

    if (obj === 'player1_score') {
      newRound.teams[0].score = event.target.value
      if (event.target.value === 'V' || _.first(event.target.value) === 'V') {
        setPlayer1Victory(true)
        setPlayer2Victory(false)
      }
    } else if (obj === 'player2_score') {
      newRound.teams[1].score = event.target.value
      if (event.target.value === 'V' || _.first(event.target.value) === 'V') {
        setPlayer1Victory(false)
        setPlayer2Victory(true)
      }
    } else {
      newRound[obj] = event.target.value
    }

    setRound(newRound)
    props.onMatchScore(newRound)
  }

  const handleVictory = (event, obj) => {
    if (event.target.checked) {
      if (obj === 'player1') {
        setPlayer1Victory(true)
        setPlayer2Victory(false)
      }
      if (obj === 'player2') {
        setPlayer1Victory(false)
        setPlayer2Victory(true)
      }
    }
  }

  const handleHelpNotification = () => {
    const helpKey = 'advancedStatsHelp'
    if (!isAdvancedHelpVisible) {
      notification.open({
        message: 'Advance Statistics Entry',
        description: (
          <table>
            <tr>
              <th>Key</th>
              <th>Action</th>
            </tr>
            <tr>
              <td>a</td>
              <td>Assault</td>
            </tr>
            <tr>
              <td>c</td>
              <td>Clean Contact</td>
            </tr>
            <tr>
              <td>v</td>
              <td>Delayed Assault</td>
            </tr>
            <tr>
              <td>d</td>
              <td>Disarm</td>
            </tr>
            <tr>
              <td>f</td>
              <td>First Contact</td>
            </tr>
            <tr>
              <td>h</td>
              <td>Honor</td>
            </tr>
            <tr>
              <td>i</td>
              <td>Indirect</td>
            </tr>
            <tr>
              <td>n</td>
              <td>Intercept</td>
            </tr>
            <tr>
              <td>o</td>
              <td>Out of Bounds</td>
            </tr>
            <tr>
              <td>p</td>
              <td>Priority</td>
            </tr>
            <tr>
              <td>r</td>
              <td>Return</td>
            </tr>
            <tr>
              <td>s</td>
              <td>Second Violation</td>
            </tr>
            <tr>
              <td>t</td>
              <td>Third Violation</td>
            </tr>
          </table>
        ),
        duration: 0,
        key: helpKey
      })
    } else {
      notification.close(helpKey)
    }

    setIsAdvancedHelpVisible(!isAdvancedHelpVisible)
  }

  return (
    <>
      <Row key={round.id} style={cardStyle}>
        <div style={{ position: 'absolute', top: '4.5em', right: '.5em' }} onClick={handleHelpNotification}><Button shape='circle' size='large' type='info'><QuestionCircleOutlined /></Button></div>
        <Col span={24} style={{ border: '1px solid #000' }}><span style={{ fontWeight: 'bold', paddingLeft: '.5em' }}>Match:</span> {round.id}</Col>
        <Col span={24} style={{ border: '1px solid #000' }}>
          <Row>
            <Col span={5} style={{ paddingLeft: '.5em' }}>Name</Col>
            {_.times(props.config.score, (num) =>
              <Col span={1} style={{ textAlign: 'center', border: '1px solid #000' }}>{num + 1}</Col>
            )}
            <Col span={3} style={{ textAlign: 'center', border: '1px solid #000' }}>Score</Col>
            <Col span={1} style={{ textAlign: 'center', border: '1px solid #000' }}>V</Col>
          </Row>
        </Col>
        <Col span={24} style={{ border: '1px solid #000' }}>
          <Row>
            <Col span={5} style={{ textAlign: 'right', paddingRight: '1em' }}>{round?.teams?.[0]?.name}</Col>
            {_.times(props.config.score, (num) =>
              <Col span={1}><Input name={`player1_${num + 1}`} className={round?.teams?.[0]?.advanced?.[num] === 'x' ? 'disabled-advanced' : ''} onKeyDown={(e) => handleAdvancedPoints(e, round?.teams?.[0]?.id, round?.teams?.[1]?.id, num)} value={round?.teams?.[0].advanced[num]} /></Col>
            )}
            <Col span={3}><Input value={round?.teams?.[0]?.score} onChange={(e) => handleChange(e, 'player1_score')} /></Col>
            <Col span={1} style={{ textAlign: 'center', paddingTop: '.35em' }}><Checkbox checked={player1Victory} onChange={(e) => handleVictory(e, 'player1')} /></Col>
          </Row>
        </Col>
        <Col span={24} style={{ border: '1px solid #000' }}>
          <Row>
            <Col span={5} style={{ textAlign: 'right', paddingRight: '1em' }}>{round?.teams?.[1]?.name}</Col>
            {_.times(props.config.score, (num) =>
              <Col span={1}><Input name={`player2_${num + 1}`} className={round?.teams?.[1]?.advanced?.[num] === 'x' ? 'disabled-advanced' : ''} onKeyDown={(e) => handleAdvancedPoints(e, round?.teams?.[1]?.id, round?.teams?.[0]?.id, num)} value={round?.teams?.[1].advanced[num]} /></Col>
            )}
            <Col span={3}><Input value={round?.teams?.[1]?.score} onChange={(e) => handleChange(e, 'player2_score')} /></Col>
            <Col span={1} style={{ textAlign: 'center', paddingTop: '.35em' }}><Checkbox checked={player2Victory} onChange={(e) => handleVictory(e, 'player2')} /></Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row>
            <Col span={12} style={{ border: '1px solid #000', paddingLeft: '1em' }}>
              <Row>
                <Col span={6}>Referee:</Col>
                <Col span={18}><Input onChange={(e) => handleChange(e, 'referee')} value={round.referee} /></Col>
              </Row>
            </Col>
            <Col span={12} style={{ border: '1px solid #000', paddingLeft: '1em' }}>
              <Row>
                <Col span={6}>Scorekeeper:</Col>
                <Col span={18}><Input onChange={(e) => handleChange(e, 'scorekeeper')} value={round.scorekeeper} /></Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default TableScoreCard
